// Hard session swap means there's nothing to "switch back" from — the
// admin is fully signed in as the user. Banner intentionally renders
// nothing. Kept as a no-op component so existing imports/mounts in
// index.js keep working without a code-split shuffle.
//
// To go back to admin: sign out via the regular logout flow, then sign
// in again with admin credentials.
const ImpersonationBanner = () => null;

export default ImpersonationBanner;
